// Minimal classnames join — the ported components only ever pass strings
// and conditionals, so no tailwind-merge needed here.
export function cn(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(" ");
}
